import { render, staticRenderFns } from "./PUserSignup.vue?vue&type=template&id=311b939a&"
import script from "./PUserSignup.vue?vue&type=script&lang=ts&"
export * from "./PUserSignup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports